{
 "background_workers": 1,
 "dns_multitenant": true,
 "file_watcher_port": 6789,
 "frappe_user": "caratred",
 "gunicorn_workers": 13,
 "live_reload": true,
 "rebase_on_pull": false,
 "redis_cache": "redis://127.0.0.1:13002",
 "redis_queue": "redis://127.0.0.1:11002",
 "redis_socketio": "redis://127.0.0.1:13002",
 "restart_supervisor_on_update": true,
 "restart_systemd_on_update": false,
 "serve_default_site": true,
 "shallow_clone": true,
 "socketio_port": 9002,
 "use_redis_auth": false,
 "webserver_port": 8002
}